// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__369RW","buttons":"SendReceipts_buttons__2-Nl0","email":"SendReceipts_email__1ArKR","bookApptTitle":"SendReceipts_bookApptTitle__3deMZ"};